export default __webpack_public_path__ + "static/media/wasp-tequila.26c45ea4.png";